import React, { Component } from 'react'

class Toggle extends Component {
	clickToggle = _ => {
		this.props.toggleChangeCallback()
	}

	render(){
		const {
			hideLabels,
			toggleState,
			toggleOptions,
			greyWhenUnselected
		} = this.props

		let toggleClassName = 'left';

		if(toggleState == 1){
			toggleClassName = 'right';
		}else if(greyWhenUnselected){
			toggleClassName += ' grey'
		}

		return (
			<div className={"toggle clear "+toggleClassName} onClick={_ => {this.clickToggle()}}>
				{ !hideLabels &&
					<label>
						{ toggleOptions[0].name }
					</label>
				}
				<div>
					<i></i>
				</div>
				{ !hideLabels &&
					<label>
						{ toggleOptions[1].name }
					</label>
				}
			</div>
		);
	}

} export default Toggle